/* eslint-disable no-undef */
import getHostEndpoint from '@/utils/getHostEndpoint';
export default function useNodeUrls() {
  const NODE_HOST = ref(process.env.VUE_APP_NODE_API);
  if (getHostEndpoint('node')) {
    NODE_HOST.value = getHostEndpoint('node');
  }
  NODE_HOST.value += '/api/v2';
  return {
    NODE_HOST
  };
}